var $ = require('jquery');
var Luminous = require('luminous-lightbox').LuminousGallery;

var ProductGallery = function ($imageWrapper, $mobileImageWrapper) {
    this.$wrapper = $imageWrapper;
    this.$mobileWrapper = $mobileImageWrapper;

    this.configure(this.$wrapper);

    // Configure mobile
    var mobileLuminous = new Luminous(
        $mobileImageWrapper.get(0).querySelectorAll('.product-image--featured--item')
    );
    //this.configure(this.$mobileWrapper);
};

ProductGallery.prototype.configure = function ($wrapper) {
    // Click on thumbnails
    var $imgList = $wrapper.find('.product-image--thumbnails');
    $imgList.on('click', 'img', this.onClickThumbnail.bind(this));

    // Zoom on image
    this.initLightBox($wrapper);
};


ProductGallery.prototype.onClickThumbnail = function (event) {
    event.preventDefault();
    var $clickedImage = $(event.currentTarget);
    var url = $clickedImage.attr('src');

    var $featured = $clickedImage.parents('.product-details-img');
    var $viewer = $featured.find('.product-image--featured');
    $viewer.find('a').attr('href', url);
    $viewer.find('img').attr('src', url);
};

ProductGallery.prototype.initLightBox = function ($wrapper) {
    this.luminous = new Luminous($wrapper.get(0).querySelectorAll('.product-image--featured--item'));
};

module.exports = ProductGallery;